import React, { useState } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../values/colors';

interface SearchBarProps {
    textFilter: string,
    setTextFilter: React.Dispatch<React.SetStateAction<string>>;
}

const SearchBar: React.FC<SearchBarProps> = ({textFilter, setTextFilter}) => {
    const searchIcon = require('../../resources/search-primary.png');

    const [ isFocused, setIsFocused ] = useState(false);

    const handleFocus = () => {
        setIsFocused(true)
    }

    const handleBlur = () => {
        setIsFocused(false)
    }

    return (
        <Bar $isFocused={isFocused}>
            <SearchIcon src={searchIcon} alt="search" />
            <SearchBarStyle 
                value={textFilter} 
                placeholder="Search by ID or Name"
                onChange={e => setTextFilter(e.target.value)}
                onFocus={handleFocus}
                onBlur={handleBlur} />
        </Bar>
    )
}

// #region Styles
interface BarProps {
    $isFocused?: boolean;
}

const Bar = styled.div<BarProps>`
    box-shadow: rgba(0, 0, 0, 0.14) 0px 4px 8px 4px;
    margin: 10px;
    // padding: 20px;
    background-color: white;
    border-radius: 20px;
    height: 40px;
    display: grid;
    grid-template-columns: 40px 1fr;
`;

const SearchIcon = styled.img`
    height: 20px;
    width: 20px;
    margin: 10px;
`;

const SearchBarStyle = styled.input`
    height: 40px;
    width: 200px;
    background-color: transparent;
    border: 0px;

    &:focus-visible {
        outline: 0px;
    }
`;
// #endregion

export default SearchBar;